import React, { createContext, useContext, useState } from 'react';
import { CreateRequestGlobalDialog } from 'features/Dashboard/Request/CreateRequestDialog/global-dialog';
import { ConfirmRequestGlobalDialog } from 'features/Dashboard/Request/ConfirmRequestDialog/global-dialog';
import { MessageDeliveryErrorGlobalDialog } from 'features/Dashboard/MessageRequest/MessageDeliveryErrorDialog/global-dialog';
import { ConfirmRejectionGlobalDialog } from 'features/Dashboard/DocumentView/ConfirmRejectionDialog/global-dialog';
import { ConfirmPurgeDocumentGlobalDialog } from 'features/Dashboard/DocumentView/ConfirmPurgeDocumentDialog/global-dialog';
import { CustomRejectionGlobalDialog } from 'features/Dashboard/DocumentView/CustomRejectionDialog/global-dialog';
import { ConfirmPurgeDriverGlobalDialog } from 'features/Dashboard/PurgeDriver/ConfirmPurgeDriverDialog/global-dialog';
import { ConfirmPurgeDocumentForeverGlobalDialog } from 'features/Dashboard/DocumentView/ConfirmPurgeDocumentForeverDialog/global-dialog';
import { ConfirmEditDocumentTypeGlobalDialog } from '../../../../../../features/Dashboard/EditDocumentType/ConfirmEditDocumentTypeDialog/global-dialog';

export const DIALOG_TYPES = {
  CREATE_REQUEST_DIALOG: 'CREATE_REQUEST_DIALOG',
  CONFIRM_REQUEST_DIALOG: 'CONFIRM_REQUEST_DIALOG',
  MESSAGE_DELIVERY_ERROR_DIALOG: 'MESSAGE_DELIVERY_ERROR_DIALOG',
  CONFIRM_REJECTION_GLOBAL_DIALOG: 'CONFIRM_REJECTION_GLOBAL_DIALOG',
  CONFIRM_PURGE_DOCUMENT_GLOBAL_DIALOG: 'CONFIRM_PURGE_DOCUMENT_GLOBAL_DIALOG',
  CUSTOM_REJECTION_GLOBAL_DIALOG: 'CUSTOM_REJECTION_GLOBAL_DIALOG',
  CONFIRM_PURGE_DRIVER_GLOBAL_DIALOG: 'CONFIRM_PURGE_DRIVER_GLOBAL_DIALOG',
  CONFIRM_PURGE_DOCUMENT_FOREVER_GLOBAL_DIALOG:
    'CONFIRM_PURGE_DOCUMENT_FOREVER_GLOBAL_DIALOG',
  CONFIRM_EDIT_DOCUMENT_TYPE_GLOBAL_DIALOG:
    'CONFIRM_EDIT_DOCUMENT_TYPE_GLOBAL_DIALOG',
};

const DIALOG_COMPONENTS: any = {
  [DIALOG_TYPES.CREATE_REQUEST_DIALOG]: CreateRequestGlobalDialog,
  [DIALOG_TYPES.CONFIRM_REQUEST_DIALOG]: ConfirmRequestGlobalDialog,
  [DIALOG_TYPES.CONFIRM_REJECTION_GLOBAL_DIALOG]: ConfirmRejectionGlobalDialog,
  [DIALOG_TYPES.CONFIRM_PURGE_DOCUMENT_GLOBAL_DIALOG]:
    ConfirmPurgeDocumentGlobalDialog,
  [DIALOG_TYPES.MESSAGE_DELIVERY_ERROR_DIALOG]:
    MessageDeliveryErrorGlobalDialog,
  [DIALOG_TYPES.CUSTOM_REJECTION_GLOBAL_DIALOG]: CustomRejectionGlobalDialog,
  [DIALOG_TYPES.CONFIRM_PURGE_DRIVER_GLOBAL_DIALOG]:
    ConfirmPurgeDriverGlobalDialog,
  [DIALOG_TYPES.CONFIRM_PURGE_DOCUMENT_FOREVER_GLOBAL_DIALOG]:
    ConfirmPurgeDocumentForeverGlobalDialog,
  [DIALOG_TYPES.CONFIRM_EDIT_DOCUMENT_TYPE_GLOBAL_DIALOG]:
    ConfirmEditDocumentTypeGlobalDialog,
};

type GlobalDialogContext = {
  showDialog: (dialogType: string, dialogProps?: any) => void;
  hideDialog: () => void;
  store: any;
};

const initialState: GlobalDialogContext = {
  showDialog: () => {
    return;
  },
  hideDialog: () => {
    return;
  },
  store: {},
};

const GlobalDialogContext = createContext(initialState);
export const useGlobalDialogContext = () => useContext(GlobalDialogContext);

export const GlobalDialog = ({ children }: { children: JSX.Element }) => {
  const [store, setStore] = useState<object>();
  // @ts-ignore
  const { dialogType, dialogProps } = store || {};

  const showDialog = (dialogType: string, dialogProps: any = {}) => {
    setStore({
      ...store,
      dialogType,
      dialogProps,
    });
  };

  const hideDialog = () => {
    setStore({
      ...store,
      dialogType: null,
      dialogProps: {},
    });
  };

  const renderComponent = () => {
    const DialogComponent = DIALOG_COMPONENTS[dialogType];
    if (!dialogType || !DialogComponent) {
      return null;
    }
    return <DialogComponent id="global-dialog" {...dialogProps} />;
  };
  return (
    <GlobalDialogContext.Provider value={{ store, showDialog, hideDialog }}>
      {renderComponent()}
      {children}
    </GlobalDialogContext.Provider>
  );
};
